<template>
    <div id="time-picker">
        <van-picker show-toolbar cancel-button-text="清空" ref="timePicker" :columns="timeColumns" @change="onChange" @confirm="selTime"/>
    </div>
</template>

<script>
export default {
  name: "TimePicker",
  data() {
    return {
      columns: {},
      timeColumns: []
    };
  },
  props: {
    index: {
      type: Number,
      require: false
    }
  },
  created() {
    this.setTime();
  },
  methods: {
    //  @cancel="cancelTime" @change="onChange"
    setTime() {
      let hour = new Date().getHours();
      let minute = new Date().getMinutes();
      let hours = [];
      let minutes = [];
      let h1 = hour;
      let m1 = minute;
      for (let i = hour; i <= 23; i++) {
        hours.push(h1 < 10 ? "0" + h1 + "时" : h1 + "时");
        h1++;
      }
      let hours1 = [];
      for (let i = 0; i <= 23; i++) {
        hours1.push(i < 10 ? "0" + i + "时" : i + "时");
      }
      for (let i = minute; i <= 59; i++) {
        minutes.push(m1 < 10 ? "0" + m1 + "分" : m1 + "分");
        m1++;
      }
      let minutes1 = [];
      for (let i = 0; i <= 59; i++) {
        minutes1.push(i < 10 ? "0" + i + "分" : i + "分");
      }

      let columns = {};
      columns.今天 = {};
      columns.明天 = {};
      columns.后天 = {};
      for (let i = 0; i < hours.length; i++) {
        if (i === 0) {
          columns.今天[hours[i]] = minutes;
        } else {
          columns.今天[hours[i]] = minutes1;
        }
      }
      for (let i = 0; i < hours1.length; i++) {
        columns.明天[hours1[i]] = minutes1;
        columns.后天[hours1[i]] = minutes1;
      }
      this.columns = columns;
      this.timeColumns = [
        {
          values: Object.keys(columns),
          className: "column1"
        },
        {
          values: Object.keys(columns.今天),
          className: "column2",
          defaultIndex: 0
        },
        {
          values: columns.今天[hours[0]],
          className: "column3",
          defaultIndex: 0
        }
      ];
    },
    onChange(picker, values, i) {
      if (i === 0) {
        picker.setColumnValues(1, Object.keys(this.columns[values[0]]));
        picker.setColumnValues(
          2,
          this.columns[values[0]][this.$refs.timePicker.getColumnValue(1)]
        );
      }
      if (i === 1) {
        picker.setColumnValues(2, this.columns[values[0]][values[1]]);
      }
    },
    selTime(value, index) {
      let obj = {
        index: this.index,
        value: {
          value,
          index
        }
      };
      this.$emit("confirm", obj);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
